import { m } from '@sohanscript/i18n';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { ErrorComponent } from './error';
import { Button } from './ui/button';

export function InternalServerError({ error }: ErrorComponentProps) {
	return (
		<ErrorComponent
			action={
				<Button
					icon="lucide:rotate-ccw"
					className="w-fit cursor-pointer"
					onClick={() => window.location.reload()}
				>
					{m.error_try_again()}
				</Button>
			}
			message={
				error instanceof Error ? error.message : m.error_internal_server_error()
			}
		/>
	);
}
